import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: '[app-square-vent]',
    templateUrl: './square-vent.component.html',
    styleUrl: './square-vent.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SquareVentComponent {
  x = input(0);
  y = input(0);
  width = input(200);
  height = input(200);
}
